const filterCollections = {
  'filter-collections-breadcrumbs': 'Filter collections',
  'filter-collections-form-groups-field': 'Groups',
  'filter-collections-form-groups-hint': 'Groups are shown in search left to right, based on their position in the priority list (top = leftmost)',
  'filter-collections-form-groups-placeholder': 'Choose groups',
  'filter-collections-groups-priority': 'Groups priority',
  'filter-collections-groups-priority-help': 'Set the desired priority of groups',
  'filter-collections-groups-not-selected': 'Groups not selected',
  'filters-filter-collection-title': 'Filters collection',
};

export default filterCollections;
